export const BRAND = {
  name: "M Construction",
  full: "M Construction LLC",
  alias: "Marquez Construction SWFL",
  logo: "/logo.png",
  phone: "239-457-4157",
  phoneHref: "tel:+12394574157",
  email: "Marquezconstructionswfl@gmail.com",
  area: "Southwest Florida",
  taglineTop: ["Built on", "Experience.", "Driven by", "Quality."],
  descriptors: ["Reliable", "Professional", "Dedicated"],
};

export const SERVICES = [
  {
    n: "01",
    title: "Land Clearing",
    desc: "Full-site clearing of brush, trees, and debris — opening your lot for whatever comes next.",
    img: "/land-clearing.webp",
  },
  {
    n: "02",
    title: "Mulching",
    desc: "Forestry mulching that grinds vegetation into nutrient-rich ground cover in a single clean pass.",
    img: "/mulching.webp",
  },
  {
    n: "03",
    title: "Material Delivery",
    desc: "Baserock, fill, and aggregate — delivered, spread, and compacted right on your schedule.",
    img: "/dirt-hauling.webp",
  },
  {
    n: "04",
    title: "House Pads",
    desc: "Properly graded and compacted foundation area built to the required elevation, providing a stable base before concrete begins.",
    img: "/house-pad.webp",
  },
  {
    n: "05",
    title: "Grading & Excavating",
    desc: "All types of grading and excavation — from lot scrape down to precise final grade.",
    img: "/grading-excavating.webp",
  },
  {
    n: "06",
    title: "Septic Install",
    desc: "Complete septic system installation — permitted, engineered, and built to code.",
    img: "/septic-install.webp",
  },
  {
    n: "07",
    title: "Culvert Install",
    desc: "Driveway and drainage culverts set for proper water flow and dependable access.",
    img: "/culvert-install.webp",
  },
  {
    n: "08",
    title: "Shell Construction",
    desc: "Foundation, concrete block, and trusses — the structural shell of your entire build.",
    img: "/shell-construction.webp",
  },
  {
    n: "09",
    title: "Concrete",
    desc: "Flatwork, footers, and slabs — poured clean, finished right, and made to last.",
    img: "/concrete.webp",
  },
];

export const CHAPTERS = [
  {
    n: "01",
    title: "Built on Experience",
    body: "Decades of dirt under the tracks. Every job starts with crews who've seen the ground, read the site, and know exactly how to move it. No guesswork — just proven site work.",
  },
  {
    n: "02",
    title: "Driven by Quality",
    body: "We don't cut corners to hit a number. Compacted pads, clean grades, and finished concrete that holds. When we leave a site, it's done right the first time.",
  },
  {
    n: "03",
    title: "On Time, On Budget",
    body: "Your build depends on ours. We show up when we say, deliver what we quote, and keep your project moving — residential and commercial alike, across Southwest Florida.",
  },
];

export const TRUST = [
  { title: "Experienced Crew", desc: "Seasoned operators on every machine." },
  { title: "Dependable Service", desc: "We show up and follow through." },
  { title: "On Time, On Budget", desc: "No surprises when the work's done." },
  { title: "Honest & Reliable", desc: "Straight quotes, straight talk." },
];

export const REVIEWS = [
  {
    name: "Jason R.",
    location: "Cape Coral, FL",
    service: "House Pad & Grading",
    text: "Pad came out dead-level and passed inspection on the first try. Crew showed up when they said they would and the price didn't move an inch from the quote.",
  },
  {
    name: "Maria G.",
    location: "Lehigh Acres, FL",
    service: "Land Clearing & Mulching",
    text: "They cleared our overgrown acre in a day and left it looking clean, not torn up. Fast, respectful, and honest about what the job actually needed.",
  },
  {
    name: "Tom & Kelly S.",
    location: "North Fort Myers, FL",
    service: "Septic Install",
    text: "Full septic system permitted and installed with zero headaches on our end. They handled the county, the inspection, everything. Wish every contractor worked like this.",
  },
  {
    name: "Dave P.",
    location: "Punta Gorda, FL",
    service: "Culvert Install",
    text: "Culvert set right the first time and the driveway drains perfectly even after heavy storms. Straight talk, fair price, quality work.",
  },
  {
    name: "Carlos M.",
    location: "Fort Myers, FL",
    service: "Shell Construction",
    text: "From the slab to the trusses, the shell went up on schedule and the block work is some of the cleanest I've seen. These guys build like it's their own house.",
  },
];

export const GALLERY = [
  { img: "/shell-construction.webp", label: "Shell" },
  { img: "/house-pad.webp", label: "House Pad" },
  { img: "/dirt-hauling.webp", label: "Hauling" },
  { img: "/grading-excavating-2.webp", label: "Excavating" },
  { img: "/concrete.webp", label: "Concrete" },
  { img: "/culvert-install.webp", label: "Culvert" },
];
